<template>
    <div class="grid-container layout-list">
        <div class="static-header flex-container flex-wrap align-middle align-justify">
            <slot name="title"></slot>
            <slot name="action"></slot>
        </div>
        <div class="list-wrapper flex-container flex-dir-column medium-flex-dir-row">
            <slot name="sidebar"></slot>
            <div class="flex-child-auto cell">
                <template v-if="!loading">
                    <slot name="table"></slot>
                    <ul class="news-list grid-y grid-padding-x grid-padding-y no-bullet" v-if="length > 0">
                        <slot></slot>
                    </ul>
                    <bmr-no-results v-else></bmr-no-results>
                </template>
                <bmr-spinner padding="16px" :center="true" v-else></bmr-spinner>
                <slot name="pagination"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['loading', 'length'],
};
</script>

<style lang="scss" scoped>
.static-header {
    flex-wrap: wrap;
    h1 {
        margin-right: 10px;
    }
    > * {
        margin: 7.5px 0;
    }
}
select {
    width: auto;
    margin: 0;
}
.list-wrapper {
    position: relative;
    padding: 10px 0;
    @include breakpoint(medium) {
        padding: 65px 50px;
        align-items: flex-start;
    }
    &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        background-color: $solid-white;
        border: 1px solid $c-border-color;
        z-index: -1;
    }
}
.filters-wrapper {
    padding: 25px;
    background: $c-filter-background;
    margin: 1rem;
    flex-shrink: 0;
    @include breakpoint(medium) {
        max-width: 250px;
    }
    label {
        display: flex;
        align-items: baseline;
        @include rem-typo(14px);
        user-select: none;
        margin-bottom: 10px;
    }
    input[type="checkbox"] {
        margin-bottom: 0;
    }
}
.search-wrapper {
    position: relative;
    &::after {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        background-image: url("~@/assets/svg/icon-search.svg");
        background-repeat: no-repeat;
        background-size: contain;
    }
}
.search-input {
    @include rem-typo(13px);
    border-radius: 2px;
    padding: 16px;
    padding-right: 40px;
    border: 0;
    color: $c-atelier-light;
    width: 100%;
    &::placeholder {
        font-style: italic;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/LayoutList.vue